/*
  Morgen in huis op de productkaart, versie 1 (6 oktober 2026)

  Vult de badge van snippets/express-delivery-hca.liquid (de kaartjes op de
  homepage, collecties en zoekresultaten). Rekent met dezelfde regels als de
  voorraadindicator op de productpagina (versie 27):
    verzenddagen maandag tot en met vrijdag
    afkaptijd 15:00, op maandag 13:30
    bezorgdagen maandag tot en met zaterdag
    1 dag transit met PostNL, naar Duitsland 2 werkdagen met DHL
  Valt de bezorging morgen, dan staat er "Morgen in huis". Anders de dag
  waarop het bezorgd wordt, bijvoorbeeld "Dinsdag in huis".

  De berekening gebeurt in de browser omdat Shopify pagina's cachet; een tijd
  die in Liquid wordt uitgerekend kan dan al uren oud zijn.
*/
(function () {
  if (window.__glznMorgenInHuis) return;
  window.__glznMorgenInHuis = true;

  var VERZENDDAGEN = [1, 2, 3, 4, 5];
  var BEZORGDAGEN = [1, 2, 3, 4, 5, 6];
  var CUTOFF_STD = 15 * 60;
  var CUTOFF_MA = 13 * 60 + 30;

  function afkap(d) { return d.getDay() === 1 ? CUTOFF_MA : CUTOFF_STD; }
  function nu() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' })); }
  function dag0(d) { var x = new Date(d); x.setHours(0, 0, 0, 0); return x; }
  function plus(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }

  function eersteVerzenddag(n) {
    var m = n.getHours() * 60 + n.getMinutes();
    if (VERZENDDAGEN.indexOf(n.getDay()) > -1 && m < afkap(n)) return dag0(n);
    var d = plus(dag0(n), 1);
    while (VERZENDDAGEN.indexOf(d.getDay()) === -1) d = plus(d, 1);
    return d;
  }
  function bezorgingNa(v, transit) {
    var d = v;
    for (var t = 0; t < transit; t++) {
      d = plus(d, 1);
      while (BEZORGDAGEN.indexOf(d.getDay()) === -1) d = plus(d, 1);
    }
    return d;
  }

  // 13 oktober 2026: ook Engels en Frans.
  var TEKST = {
    nl: { loc: 'nl-NL', morgen: 'Morgen in huis', dag: function (d) { return d + ' in huis'; } },
    de: { loc: 'de-DE', morgen: 'Morgen bei dir', dag: function (d) { return d + ' bei dir'; } },
    en: { loc: 'en-GB', morgen: 'Delivered tomorrow', dag: function (d) { return 'Delivered ' + d; } },
    fr: { loc: 'fr-FR', morgen: 'Livré demain', dag: function (d) { return 'Livré ' + d.toLowerCase(); } }
  };

  function tekst(el) {
    var t = TEKST[el.getAttribute('data-taal')] || TEKST.nl;
    var transit = el.getAttribute('data-land') === 'DE' ? 2 : 1;
    var n = nu();
    var bezorg = bezorgingNa(eersteVerzenddag(n), transit);
    if (dag0(bezorg).getTime() === dag0(plus(n, 1)).getTime()) {
      return t.morgen;
    }
    var dag = bezorg.toLocaleDateString(t.loc, { weekday: 'long' });
    dag = dag.charAt(0).toUpperCase() + dag.slice(1);
    return t.dag(dag);
  }

  function teken() {
    var lijst = document.querySelectorAll('[data-glzn-morgen]');
    for (var i = 0; i < lijst.length; i++) {
      var el = lijst[i];
      var t = tekst(el);
      var span = el.querySelector('[data-glzn-morgen-tekst]');
      if (span && span.textContent !== t) span.textContent = t;
      if (el.hasAttribute('data-wacht')) el.removeAttribute('data-wacht');
    }
  }

  var wacht;
  function later() { clearTimeout(wacht); wacht = setTimeout(teken, 100); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', teken); else teken();

  // Kaarten die later binnenkomen (filters, carrousels, oneindig scrollen).
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { later(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // De afkaptijd verschuift terwijl de pagina openstaat.
  setInterval(teken, 60000);
})();
